<template>
  <div class="c-survey-answer text-primary">
    <div v-if="!isDesktop" class="c-survey-answer__mobile-header">
      <h6 class="c-survey-answer__survey">
        {{ this.$route.meta.prediction ? "Pronostico" : "Survey" }}
      </h6>
      <div
        class="c-survey-answer__close"
        @click="redirect"
        v-html="closeIcon"
      ></div>
    </div>
    <div class="c-survey-answer__heading">
      <div class="c-survey-answer__current-progress">
        <CurrentStep
          :current="currentStep"
          :max="maxStep"
          class="justify-content-center"
          :class="{ 'mb-2': !isDesktop, 'ml-4': isDesktop }"
          v-if="maxStep > 1"
        />
        <div class="c-survey-answer__progress">
          <Progress :value="progress" v-if="maxStep > 1" small />
        </div>
      </div>
      <router-link
        v-if="isDesktop"
        to="/dashboard"
        class="c-survey__redirect-link primary-text"
        >{{
          this.$route.meta.prediction
            ? this.$i18n.t("Esci dal pronostico")
            : this.$i18n.t("Esci dalla Survey")
        }}</router-link
      >
    </div>
    <h4 class="c-survey-answer__question">
      {{ question.text }}
    </h4>
    <component
      :is="rednerInput"
      v-model="question.answer"
      :type="question.type"
      :options="question.options"
      :question="question"
      @input="onInput"
    />
    <div class="c-survey-answer__actions" v-if="!isDesktop">
      <RoundedButton
        v-if="currentStep > 1"
        type="prev"
        @action="goPrev"
        mode="transparent"
      />
      <RoundedButton
        mode="primary"
        :disabled="nextDisabled"
        :type="RoundedButtonType"
        @action="goNext"
        class="ml-3"
      />
    </div>
    <div
      class="c-survey-answer__actions c-survey-answer__actions--desktop"
      v-if="isDesktop"
    >
      <button
        v-if="currentStep > 1"
        type="button"
        class="btn btn-outline-primary c-survey-answer__actions__btn"
        @click="goPrev"
      >
        {{ $t("Indietro") }}
      </button>
      <button
        type="button"
        class="btn btn-primary c-survey-answer__actions__btn"
        :disabled="nextDisabled"
        @click="goNext"
      >
        {{ btnName }}
      </button>
    </div>
  </div>
</template>

<script>
import closeIcon from "@/assets/svg/rebuild/close.svg";

import CurrentStep from "../common/CurrentStep";
import Progress from "../common/Progress";
import Inputs from "../common/Inputs";
import RoundedButton from "../common/RoundedButton";
import SelectOptions from "./SelectOptions";

import { mapGetters } from "vuex";

export default {
  name: "SurveyAnswer",
  components: {
    CurrentStep,
    Progress,
    ...Inputs,
    RoundedButton,
    SelectOptions
  },
  props: ["showingQuestion", "currentStep", "maxStep"],
  data() {
    return {
      closeIcon,
      question: {}
    };
  },
  computed: {
    ...mapGetters(["isDesktop"]),
    progress() {
      return (this.currentStep / this.maxStep) * 100;
    },
    RoundedButtonType() {
      return this.currentStep !== this.maxStep ? "prossima" : "controlla";
    },
    btnName() {
      return this.currentStep !== this.maxStep
        ? this.$i18n.t("Avanti")
        : this.$i18n.t("Invia");
    },
    nextDisabled() {
      return !this.question.answer.length;
    },
    rednerInput() {
      //component for select on desktop

      if (
        this.isDesktop &&
        ["select", "multi-select"].includes(this.question.type)
      ) {
        return "SelectOptions";
      }

      //components for mobile and tablet
      const components = {
        date: "Date",
        select: "SelectOptions",
        "multi-select": "SelectOptions"
      };
      return components[this.question.type] || "Input";
    }
  },
  methods: {
    onInput() {
      this.$emit("onChangeQuestion", {
        question: this.question,
        step: this.currentStep - 1
      });
    },
    goNext() {
      this.$emit("onChangeQuestion", {
        question: this.question,
        step: this.currentStep
      });
    },
    goPrev() {
      this.$emit("onChangeQuestion", {
        question: this.question,
        step: this.currentStep - 2
      });
    },
    redirect() {
      this.$router.push("/dashboard");
    }
  },
  watch: {
    showingQuestion: {
      immediate: true,
      deep: true,
      handler(val) {
        this.question = JSON.parse(JSON.stringify(val));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.c-survey-answer {
  text-align: center;
  padding: 20px 0;
}
.c-survey-answer__question {
  text-align: left;
  font-size: 25px;
  margin: 40px 0;
}
.c-survey-answer__actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 70px;
}
.c-survey-answer__mobile-header {
  position: relative;
}
.c-survey-answer__close {
  position: absolute;
  top: 0;
  right: 20px;
}
.c-survey-answer__current-progress {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  @media (min-width: 992px) {
    margin-top: 0;
    flex: 0 0 50%;
    max-width: 50%;
    flex-direction: row-reverse;
    align-items: center;
  }
}
.c-survey-answer__heading {
  @media (min-width: 992px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.c-survey__redirect-link {
  flex: 0 0 50%;
  max-width: 50%;
  text-align: right;
  font-weight: bold;
  font-size: 18px;
}
.c-survey-answer__progress {
  flex-grow: 1;
}
.c-survey-answer__actions--desktop {
  justify-content: center;
}
.c-survey-answer__actions__btn {
  padding: 6px 50px;
  margin: 0 10px;
  border-radius: 10px;
}
</style>
